import React from "react";

const MembershipIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5617 13.6442L17.6415 14.0329L16.1964 11.7907C16.1061 11.6454 15.898 11.6454 15.8077 11.7907L14.3626 14.0329L12.4424 13.6442C12.2657 13.6088 12.1204 13.7777 12.1754 13.9426L13.1963 17.2333C13.1963 16.876 14.4529 16.5854 16.0001 16.5854C17.5473 16.5854 18.8078 16.8799 18.8078 17.2333L19.8287 13.9426C19.8798 13.7777 19.7384 13.6088 19.5617 13.6442Z"
        fill="#57CC99"
      />
      <path d="M18.8077 17.2333C18.8077 17.5946 17.5511 17.8812 16 17.8812C14.4489 17.8812 13.1963 17.5907 13.1963 17.2333C13.1963 16.876 14.4529 16.5854 16 16.5854C17.5472 16.5854 18.8077 16.8799 18.8077 17.2333Z" />
      <path d="M10.4045 22.0633H7.30231C6.26956 22.0633 5.42529 21.2229 5.42529 20.1862V11.6533C5.42529 10.6205 6.26563 9.77625 7.30231 9.77625H10.4045V10.7579H7.30231C6.81146 10.7579 6.407 11.1585 6.407 11.6533V20.1862C6.407 20.6771 6.80753 21.0816 7.30231 21.0816H10.4045V22.0633Z" />
      <path d="M24.6984 22.0633H21.5962V21.0816H24.6984C25.1892 21.0816 25.5937 20.681 25.5937 20.1862V11.6533C25.5937 11.1624 25.1932 10.7579 24.6984 10.7579H21.5962V9.77625H24.6984C25.7311 9.77625 26.5754 10.6166 26.5754 11.6533V20.1862C26.5754 21.219 25.7351 22.0633 24.6984 22.0633Z" />
      <path d="M20.2413 24.8435H11.7632C10.7305 24.8435 9.88623 24.0031 9.88623 22.9664V8.87702C9.88623 7.84427 10.7266 7 11.7632 7H20.2413C21.274 7 22.1183 7.84034 22.1183 8.87702V22.9664C22.1183 23.9992 21.2779 24.8435 20.2413 24.8435ZM11.7593 7.9817C11.2685 7.9817 10.864 8.38224 10.864 8.87702V22.9664C10.864 23.4573 11.2645 23.8618 11.7593 23.8618H20.2373C20.7282 23.8618 21.1326 23.4612 21.1326 22.9664V8.87702C21.1326 8.38617 20.7321 7.9817 20.2373 7.9817H11.7593Z" />
    </svg>
  );
};

export default MembershipIcon;
